export enum SliderType {
  LessThan = 'LessThan',
  GreaterThan = 'GreaterThan',
  Equal = 'Equal',
}

export interface SliderEvent {
  value: number;
}

export interface SliderValue {
  type?: 'value';

  value: number;
  valueType?: SliderType;
  exclusive?: boolean;

  onChange: (event: SliderEvent) => void;
  onCommit?: (event: SliderEvent) => void;
}

export enum RangeSliderType {
  Inclusive = 'Inclusive',
  /**
   * Not implemented.
   */
  Exclusive = 'Exclusive',
}

export interface RangeSliderEvent {
  minValue: number;
  maxValue: number;
}

export interface RangeSliderValue {
  type: 'range';

  minValue: number;
  maxValue: number;
  valueType?: RangeSliderType;
  minExclusive?: boolean;
  maxExclusive?: boolean;

  onChange: (event: RangeSliderEvent) => void;
  onCommit?: (event: RangeSliderEvent) => void;
}

export enum GripType {
  Minimum = 'min',
  Maximum = 'max',
  Single = 'single',
}
